module.exports = __webpack_public_path__ + "static/Industrial-Manufacturing-1-754c2b3b3fb00a91691542641ff1356d.jpg";